import { Col, Row } from 'antd';
import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { ListPage } from 'src/components/ListPage/ListPage';
import { ListPageItem } from 'src/components/ListPage/ListPageItem';
import { RoutePaths } from 'src/core/router/RoutePaths';
import { EntityStatus } from 'src/core/StatusInfo';
import { LoanAdjustmentsRequestDtoBorrowerAllowed } from 'src/generated-api-client';
import { RequestsStatusInfo } from 'src/pages/RequestsPage/RequestsStatusInfo';
import { RequestsStore } from 'src/stores/RequestsStore/RequestsStore';
import { DateHelper } from 'src/utils/DateHelper';
import { UrlHelper } from 'src/utils/UrlHelper';
import styled from 'styled-components';

export const RequestsPage = observer(() => {
    const { t } = useTranslation();

    return (
        <ListPage
            pageName="requests"
            store={RequestsStore}
            title={t('Page.Requests.Title')}
            renderItem={(item: LoanAdjustmentsRequestDtoBorrowerAllowed) => {
                const { requestedAt, id, status, number } = item;

                const targetUrl = _.isNil(id)
                    ? id
                    : UrlHelper.getTargetUrl(RoutePaths.request, {
                          requestId: id.toString(),
                      });

                return (
                    <StyledListPageItem
                        to={targetUrl}
                        key={item.id}
                        data-testid={`list-page-item-${item.id}`}
                    >
                        <Row wrap={false} justify="space-between">
                            <Row>
                                <Col>
                                    <StyledCreatedAt data-testid="requestedAt">
                                        {requestedAt &&
                                            DateHelper.format(requestedAt)}
                                    </StyledCreatedAt>
                                </Col>
                                <Col>
                                    <StyledIdContainer data-testid="request-number">
                                        #{number}
                                    </StyledIdContainer>
                                </Col>
                            </Row>
                            <Col flex="none">
                                <EntityStatus
                                    entityName="loanAdjustmentsRequest"
                                    statusInfoMap={RequestsStatusInfo}
                                    status={status}
                                />
                            </Col>
                        </Row>
                    </StyledListPageItem>
                );
            }}
        />
    );
});

const StyledListPageItem = styled(ListPageItem)`
    min-height: auto !important;
`;

const StyledCreatedAt = styled.div`
    font-size: 16px;
    line-height: 165%;
    height: 100%;
    display: flex;
    align-items: center;

    @media (max-width: 576px) {
        font-size: 11px;
    }
`;

const StyledIdContainer = styled.div`
    font-size: 16px;
    line-height: 165%;
    color: #828b94;
    margin-left: 1em;
    height: 100%;
    display: flex;
    align-items: center;

    @media (max-width: 576px) {
        font-size: 11px;
    }
`;
